import { render, staticRenderFns } from "./AccountingBooksReceiptStandartForm.vue?vue&type=template&id=8f7c97f0&"
import script from "./AccountingBooksReceiptStandartForm.vue?vue&type=script&lang=js&"
export * from "./AccountingBooksReceiptStandartForm.vue?vue&type=script&lang=js&"
import style0 from "./AccountingBooksReceiptStandartForm.vue?vue&type=style&index=0&id=8f7c97f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports